import { render, staticRenderFns } from "./DetailPageBaseInfo.vue?vue&type=template&id=3b008df6&scoped=true"
import script from "./DetailPageBaseInfo.vue?vue&type=script&lang=js"
export * from "./DetailPageBaseInfo.vue?vue&type=script&lang=js"
import style0 from "./DetailPageBaseInfo.vue?vue&type=style&index=0&id=3b008df6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b008df6",
  null
  
)

export default component.exports